import React from "react";

import imageOne from "../../resource/arama/ceramony-video/1.png";
import imageTwo from "../../resource/arama/ceramony-video/2.png";
import imageThree from "../../resource/arama/ceramony-video/3.png";
import TitleChnage from "../../Hook/TitleChnage";

const CeramonyVideo = () => {
  TitleChnage("Ceremony Video");
  return (
    <div className="ceramonyVideo-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main  p-4">Ceremony Video</h1>

      <div className="poem-1 mt-6 h4-bold">
        <div>
          <p className="text-black">Arama Pooja – A Meritorious Event,</p>
          <p className="text-black">Annual Pooja – Forever Glorious</p>
          <p className="text-black">Await and see - A Video Illustious,</p>
          <p className="text-black">Arange your Pooja – A Marvelous Endavor.</p>
        </div>
      </div>

      <div className="test mt-6 padding-sm">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/7m-2kH14nxY?si=RDD5mH5LbsnezpHv"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>

      <div className="test mt-5 padding-sm">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/0_EXJZxTMYk?si=sAMP7NHCsA0V7fnP"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>

      <div className="test mt-5 padding-sm">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/LH-cyC-ahHs?si=pazuomtJF0PtOV5p"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>

      <div className="p-4 text-center mt-6">
        <img src={imageThree} alt="" width={200} />
      </div>

      <div className="bottom-box mt-5">
        <img src={imageTwo} alt="bottom-image" width={400} />
      </div>
    </div>
  );
};

export default CeramonyVideo;
